<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить номер диспетчерской</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="conciergeNumber" persistent max-width="400">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Измените номер диспетчерской</v-card-title>
          <v-text-field
            ref="conciergeNumber"
            v-model="conciergeNumberNew"
            label="Введите номер"
            class="pa-5"
            outlined
            dense
            hide-details
            type="number"
            :rules="[
              v => !!v || 'Обязательное поле',
              v => v >= 0 || 'Введите целое число',
            ]"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="conciergeNumber = false"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              :loading="loadingBtn"
              class="text-none"
              @click="updateConciergeNumberNew"
              :disabled="conciergeNumberNew.length < 3"
            >
              Установить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.right_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone) in updateResult.fail_doorphones" :key="doorphone.id">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ConciergeNumber',
  props: ['doorphones'],
  data () {
    return {
      conciergeNumber: false,
      loadingBtn: false,
      conciergeNumberNew: '',
      dialogResult: false,
      updateResult: {},
    };
  },
  methods: {
    ...mapActions({
      updateMassConciergeNumber: 'MainSetups/updateMassConciergeNumber',
    }),
    updateConciergeNumberNew () {
      this.$refs.conciergeNumber.validate(true);
      this.$nextTick(() => {
        if (this.conciergeNumberNew !== '') {
          const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });

          this.loadingBtn = true;
          this.updateMassConciergeNumber({
            conciergeNumber: this.conciergeNumberNew,
            doorphones: selectedDoorphoneId,
          })
            .then((res) => {
              this.conciergeNumberNew = '';
              this.conciergeNumber = false;
              this.updateResult = res;
              this.dialogResult = true;
            })
            .catch(e => {
              this.$flash_warning('Не удалось обновить номер диспетчера');
            })
            .finally(() => {
              this.loadingBtn = false;
            });
        }
      });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
